<template>
    <el-tabs>
        <el-tab-pane label="Certificate">
            <el-button type="primary" v-if="awards.length > 0" @click="$emit('export', 'showTotal')"
                size="medium" style="margin-bottom: 10px;">Download the certificate</el-button>
            <p v-if="showNoAwards" style="margin-left: 20px;">You did not receive an award for this competition</p>
            <div id="showTotal">
                <div v-for="(item, index) in awards" :key="index" class="certContainer"
                    style="margin-bottom:10px;">
                    <img src="../../../assets/image/cert_envirothon_asia.png" class="modelCert" />
                    <div class="student">{{ studentName }}</div>
                    <div class="school">{{ accountName }}</div>
                    <div class="award">{{ item.award_lable }}</div>
                    <div v-if="item.award_set_note" class="award-set-note">
                        {{ item.award_set_note }}
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="Transcript">
            <el-button type="primary" @click="$emit('export', 'showTranscript')" size="medium"
                style="margin-bottom: 10px;">Download the transcript</el-button>
            <div id="showTranscript">
                <div v-for="(item, index) in transcripts" :key="index" class="transcriptContainer1"
                    style="margin-bottom:10px;">
                    <img src="../../../assets/image/transcript_envirothon_asia.png" class="model_p" />
                    <div class="name">{{ studentName }}</div>
                    <div class="account">{{ accountName }}</div>
                    <div class="object_score">{{ item.objective_score }}</div>
                    <div class="case_score">{{ item.presentation_score }}</div>
                </div>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    name: 'AwardEnvirothon',
    props: {
        awards: Array,
        transcripts: Array,
        studentName: String,
        accountName: String,
        projectInfo: Object,
        showNoAwards: Boolean
    }
}
</script>

<style lang="scss" scoped>
.certContainer {
    position: relative;
    font-family: 'BellMT-Bold';

    .student {
        position: absolute;
        top: 510px;
        width: 210mm;
        font-size: 35px;
        font-weight: 600;
        text-align: center;
    }

    .school {
        width: 210mm;
        position: absolute;
        top: 555px;
        text-align: center;
        font-size: 28px;
        font-weight: 350;
    }

    .award {
        width: 210mm;
        position: absolute;
        top: 635px;
        text-align: center;
        font-size: 32px;
        font-weight: 500;
    }

    .award-set-note {
        width: 210mm;
        position: absolute;
        top: 690px;
        background: white;
        border: 1px solid #333;
        padding: 15px;
        margin: 0 20px;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 1.4;
        text-align: left;
    }
}

.transcriptContainer1 {
    position: relative;

    .model_p {
        width: 210mm;
        height: 295mm;
    }

    .name {
        position: absolute;
        width: 210mm;
        top: 500px;
        font-size: 42px;
        font-weight: 500;
        text-align: center;
    }

    .account {
        text-align: center;
        width: 210mm;
        position: absolute;
        top: 570px;
        font-size: 30px;
        font-weight: 400;
    }

    .object_score {
        position: absolute;
        top: 755px;
        left: 290px;
        font-size: 18px;
        font-weight: 400;
    }

    .case_score {
        position: absolute;
        top: 755px;
        left: 490px;
        font-size: 18px;
        font-weight: 400;
    }
}
</style>
